import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-12 md:py-16 lg:py-24 px-4 md:px-6 lg:px-8 bg-gradient-to-br from-primary via-primary/90 to-accent relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto max-w-4xl relative z-10">
        <div className="text-center space-y-6 md:space-y-8">
          {/* Icon */}
          <div className="flex justify-center">
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-white/20 rounded-2xl backdrop-blur-sm">
              <Icon 
                name="Heart" 
                size={48} 
                color="white" 
                strokeWidth={2}
              />
            </div>
          </div>

          {/* Heading */}
          <div className="space-y-3 md:space-y-4">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white">
              Ready to Share Your Story?
            </h2>
            <p className="text-base md:text-lg lg:text-xl text-white/90 max-w-2xl mx-auto leading-relaxed">
              Join thousands of people finding support and understanding in our safe, anonymous community. Your emotional cuts deserve to be heard.
            </p>
          </div>

          {/* CTA Button */}
          <div className="pt-4">
            <Button
              variant="secondary"
              size="xl"
              iconName="ArrowRight"
              iconPosition="right"
              onClick={() => navigate('/main-feed')}
              className="bg-white text-primary hover:bg-white/90 shadow-lg"
            >
              Enter Safe Space Now
            </Button>
          </div>

          {/* Trust indicators */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8 pt-6 md:pt-8">
            <div className="flex items-center gap-2 text-sm text-white/80">
              <Icon name="Lock" size={16} color="white" strokeWidth={2} />
              <span>100% Anonymous</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-white/80">
              <Icon name="Shield" size={16} color="white" strokeWidth={2} />
              <span>No Judgment</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-white/80">
              <Icon name="Heart" size={16} color="white" strokeWidth={2} />
              <span>Supportive Community</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;